import * as ACTION from '../constants';

const INITIAL_STATE = {
  error: null,
  loading: false,
  list: [],
  pagination: {},
};

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case ACTION.INTERVIEWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTION.INTERVIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.list || [],
        pagination:action.pagination || {},
        error: null,
      };
    case ACTION.INTERVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
